import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { AdminPortalRootState, AdminPortalDispatch } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AdminPortalDispatch>();
export const useAppSelector: TypedUseSelectorHook<AdminPortalRootState> = useSelector;